// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { number, string, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementPresetLandingPageTemplatesDataIdResult = objectOf({
  id: string,
  name: string,
  description: string,
  html: maybe(any, true),
  last_edited_at: number,
  template_id: string,
  grapes_js_data: maybe(any, true),
});
